import React from "react";
import UpgradeButton from "./UpgradeButton";

/**
 * Locked-card pattern. Used for full features that exist exactly where they'd
 * normally live (Gmail panel, Fit Score card, etc.) but are visually locked
 * behind Navigator. Children render blurred underneath.
 */
export default function LockedCard({
  feature,
  context = "",
  title,
  description,
  ctaLabel = "Unlock with Navigator",
  children,
  className = "",
  badgeLabel = "NAVIGATOR FEATURE",
  testid,
}) {
  return (
    <div
      className={`locked-card ${className}`.trim()}
      data-testid={testid || `locked-card-${feature || "generic"}`}
    >
      <div className="locked-card-badge">
        <LockIcon />
        <span>{badgeLabel}</span>
      </div>

      <div className="locked-card-corner" aria-hidden>
        <LockIcon />
      </div>

      {/* Optional placeholder content — blurred so the user sees the shape */}
      {children && (
        <div className="locked-card-blur" aria-hidden>
          {children}
        </div>
      )}

      <div className="locked-card-body">
        {title && <h3 className="locked-card-title">{title}</h3>}
        {description && <p className="locked-card-desc">{description}</p>}
        <UpgradeButton
          feature={feature}
          context={context}
          label={ctaLabel}
          variant="clay"
          testid={`locked-card-cta-${feature || "generic"}`}
        />
      </div>
    </div>
  );
}

function LockIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  );
}
